module.exports = __webpack_public_path__ + "static/img/方案图3.a824c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/方案图3.png
// module id = L56U
// module chunks = 2